import React, { createContext, useState, useContext, useCallback, useMemo, useRef } from 'react';

// Create the context
export const GroupReportDateContext = createContext();

// Custom hook to use the context
export const useGroupReportDate = () => {
  const context = useContext(GroupReportDateContext);
  if (!context) {
    throw new Error('useGroupReportDate must be used within a GroupReportDateProvider');
  }
  return context;
};

// Provider component
export const GroupReportDateProvider = ({ children }) => {
  // State for storing the data
  const [leaderchartdata, setLeaderchartdata] = useState(null);
  const [startChartdata, setStartChartdata] = useState(null);
  const [tablevaluesq, setTablevaluesq] = useState(null);
  const [tablevaluels, setTablevaluels] = useState(null);
  const [tablevaluesq2, setTablevaluesq2] = useState(null);
  const [tablevaluels2, setTablevaluels2] = useState(null);
  const [leaderselfchartdata, setLeaderselfchartdata] = useState(null);
  const [startChartdataSelfchartdata, setSelfStartChartdata] = useState(null);
  const [mindsetscore, setMindsetscore] = useState(null);
  const [mindsetscoreself, setMindsetscoreself] = useState(null);
  const lastPayloadRef = useRef({});

  const guardUpdate = useCallback((key, updater) => {
    return (data) => {
      const nextStr = JSON.stringify(data ?? null);
      if (lastPayloadRef.current[key] === nextStr) return;
      lastPayloadRef.current[key] = nextStr;
      updater(data);
    };
  }, []);

  // Functions to update the data
  const updateLeaderchartdata = useCallback(guardUpdate('leaderchartdata', setLeaderchartdata), [guardUpdate]);

  const updateStartChartdata = useCallback(guardUpdate('startChartdata', setStartChartdata), [guardUpdate]);

  const updateTablevaluesq = useCallback(guardUpdate('tablevaluesq', setTablevaluesq), [guardUpdate]);

  const updateTablevaluesqPage1 = useCallback(guardUpdate('tablevaluesq.page1', (data) => {
    setTablevaluesq(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page1: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluesqPage2 = useCallback(guardUpdate('tablevaluesq.page2', (data) => {
    setTablevaluesq(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page2: data
      };
    });
  }), [guardUpdate]);
  const updateTablevaluesqPage3 = useCallback(guardUpdate('tablevaluesq.page3', (data) => {
    setTablevaluesq(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page3: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluels = useCallback(guardUpdate('tablevaluels', setTablevaluels), [guardUpdate]);

  const updateTablevaluelsPage1 = useCallback(guardUpdate('tablevaluels.page1', (data) => {
    setTablevaluels(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page1: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluelsPage2 = useCallback(guardUpdate('tablevaluels.page2', (data) => {
    setTablevaluels(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page2: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluelsPage3 = useCallback(guardUpdate('tablevaluels.page3', (data) => {
    setTablevaluels(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page3: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluesq2 = useCallback(guardUpdate('tablevaluesq2', setTablevaluesq2), [guardUpdate]);

  const updateTablevaluesq2Page1 = useCallback(guardUpdate('tablevaluesq2.page1', (data) => {
    setTablevaluesq2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page1: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluesq2Page2 = useCallback(guardUpdate('tablevaluesq2.page2', (data) => {
    setTablevaluesq2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page2: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluesq2Page3 = useCallback(guardUpdate('tablevaluesq2.page3', (data) => {
    setTablevaluesq2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page3: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluesq2Page4 = useCallback(guardUpdate('tablevaluesq2.page4', (data) => {
    setTablevaluesq2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page4: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluels2 = useCallback(guardUpdate('tablevaluels2', setTablevaluels2), [guardUpdate]);

  const updateTablevaluels2Page1 = useCallback(guardUpdate('tablevaluels2.page1', (data) => {
    setTablevaluels2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page1: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluels2Page2 = useCallback(guardUpdate('tablevaluels2.page2', (data) => {
    setTablevaluels2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page2: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluels2Page3 = useCallback(guardUpdate('tablevaluels2.page3', (data) => {
    setTablevaluels2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page3: data
      };
    });
  }), [guardUpdate]);

  const updateTablevaluels2Page4 = useCallback(guardUpdate('tablevaluels2.page4', (data) => {
    setTablevaluels2(prevData => {
      const currentData = prevData || {};
      return {
        ...currentData,
        page4: data
      };
    });
  }), [guardUpdate]);

  const updateLeaderselfchartdata = useCallback(guardUpdate('leaderselfchartdata', setLeaderselfchartdata), [guardUpdate]);

  const updateStartChartdataSelfchartdata = useCallback(guardUpdate('startChartdataSelfchartdata', setSelfStartChartdata), [guardUpdate]);

  const updateMindsetscore = useCallback(guardUpdate('mindsetscore', setMindsetscore), [guardUpdate]);

  const updateMindsetscoreself = useCallback(guardUpdate('mindsetscoreself', setMindsetscoreself), [guardUpdate]);

  // Clear all data
  const clearAllData = useCallback(() => {
    setLeaderchartdata(null);
    setStartChartdata(null);
    setTablevaluesq(null);
    setTablevaluels(null);
    setTablevaluesq2(null);
    setTablevaluels2(null);
    setLeaderselfchartdata(null);
    setSelfStartChartdata(null);
    setMindsetscore(null);
    setMindsetscoreself(null);
  }, []);

  // Context value object
  const value = useMemo(() => ({
    // Data
    leaderchartdata,
    startChartdata,
    tablevaluesq,
    tablevaluels,
    tablevaluesq2,
    tablevaluels2,
    leaderselfchartdata,
    startChartdataSelfchartdata,
    mindsetscore,
    mindsetscoreself,

    // Update functions
    updateLeaderchartdata,
    updateStartChartdata,
    updateTablevaluesq,
    updateTablevaluesqPage1,
    updateTablevaluesqPage2,
    updateTablevaluesqPage3,
    updateTablevaluels,
    updateTablevaluelsPage1,
    updateTablevaluelsPage2,
    updateTablevaluelsPage3,
    updateTablevaluesq2,
    updateTablevaluesq2Page1,
    updateTablevaluesq2Page2,
    updateTablevaluesq2Page3,
    updateTablevaluesq2Page4,
    updateTablevaluels2,
    updateTablevaluels2Page1,
    updateTablevaluels2Page2,
    updateTablevaluels2Page3,
    updateTablevaluels2Page4,
    updateLeaderselfchartdata,
    updateStartChartdataSelfchartdata,
    updateMindsetscore,
    updateMindsetscoreself,

    // Utility functions
    clearAllData,
  }), [
    leaderchartdata,
    startChartdata,
    tablevaluesq,
    tablevaluels,
    tablevaluesq2,
    tablevaluels2,
    leaderselfchartdata,
    startChartdataSelfchartdata,
    mindsetscore,
    mindsetscoreself,
    updateLeaderchartdata,
    updateStartChartdata,
    updateTablevaluesq,
    updateTablevaluesqPage1,
    updateTablevaluesqPage2,
    updateTablevaluesqPage3,
    updateTablevaluels,
    updateTablevaluelsPage1,
    updateTablevaluelsPage2,
    updateTablevaluelsPage3,
    updateTablevaluesq2,
    updateTablevaluesq2Page1,
    updateTablevaluesq2Page2,
    updateTablevaluesq2Page3,
    updateTablevaluesq2Page4,
    updateTablevaluels2,
    updateTablevaluels2Page1,
    updateTablevaluels2Page2,
    updateTablevaluels2Page3,
    updateTablevaluels2Page4,
    updateLeaderselfchartdata,
    updateStartChartdataSelfchartdata,
    updateMindsetscore,
    updateMindsetscoreself,
    clearAllData
  ]);

  return (
    <GroupReportDateContext.Provider value={value}>
      {children}
    </GroupReportDateContext.Provider>
  );
};

export default GroupReportDateContext;
